type ImpactStyle = "light" | "medium" | "heavy" | "rigid" | "soft"

// Вне Telegram и на старых клиентах HapticFeedback нет — тихо ничего не делаем.
const hf = () => window.Telegram?.WebApp?.HapticFeedback

export const haptic = {
  selection: () => hf()?.selectionChanged?.(),
  impact: (style: ImpactStyle = "light") => hf()?.impactOccurred?.(style),
}
